import React from 'react';
import { useParams } from 'react-router-dom';
import LoanTypeForm from './LoanTypeForm';

interface ShowAlerts {
  showAlert: (message: string, severity?: 'success' | 'info' | 'warning' | 'error') => void;
  showLoading: () => void;
  hideLoading: () => void;
}

/** Editar tipo de préstamo. */
const LoanTypeEdit: React.FC<ShowAlerts> = (props) => {
  const { id } = useParams();
  return <LoanTypeForm {...props} id={id} />;
};

export default LoanTypeEdit;
